var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item_sidebar"},[_c('div',{staticClass:"wrapper_input"},[(_vm.open)?_c('CodePopup',{attrs:{"insert-code":true,"html":_vm.value},on:{"close":function($event){_vm.open=false},"done":_vm.save}}):_vm._e(),_c('v-button',{attrs:{"border":"","label":_vm.title},on:{"click":function($event){_vm.open=true}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }